import React from "react";
import { colors } from "../../themes/Colors";
import { BaseButton } from "../atoms";

const NearestButton = ({
  title,
  onViewClick,
  medicalInfoImage,
  backgroundImage,
  height,
  width,
  mobileWidth,
  mobileHeight,
}) => {
  return (
    <div
      style={{
        position: "relative",
        width: mobileWidth ? mobileWidth : 450,
        height: mobileHeight ? mobileHeight : 300,
        backgroundColor: colors.white,
        borderRadius: 8,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        // borderStyle: "solid",
        overflow: "hidden",
      }}
    >
      <img
        alt="background image"
        src={backgroundImage}
        width={"100%"}
        height={"100%"}
        style={{ borderRadius: 8 }}
      />
      <div
        style={{
          position: "absolute",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <h3 style={{ color: colors.white }}>{title}</h3>
        {onViewClick ? (
          <BaseButton label={"View"} width={120} onClick={onViewClick} />
        ) : null}

        <img
          alt="medical info logo"
          src={medicalInfoImage}
          style={{ borderRadius: 8, marginTop: 20 }}
          height={height}
          width={width}
        />
      </div>
    </div>
  );
};

export default NearestButton;
